import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

type GtagFn = (...args: unknown[]) => void

declare global {
  interface Window {
    gtag?: GtagFn
  }
}

const PREVIEW_PATH_RE = /\/preview\/[^/?#]+/g

function sanitizePreviewPath(path: string): string {
  return path.replace(PREVIEW_PATH_RE, '/preview/[redacted]')
}

function sanitizePreviewLocation(url: string): string {
  try {
    const parsed = new URL(url)
    parsed.pathname = sanitizePreviewPath(parsed.pathname)
    return parsed.toString()
  } catch {
    return sanitizePreviewPath(url)
  }
}

export default function usePageTracking() {
  const location = useLocation()

  useEffect(() => {
    if (typeof window.gtag !== 'function') return

    const pagePath = sanitizePreviewPath(`${location.pathname}${location.search}${location.hash}`)
    const pageLocation = sanitizePreviewLocation(window.location.href)

    window.gtag('event', 'page_view', {
      page_location: pageLocation,
      page_path: pagePath,
      page_title: document.title,
    })
  }, [location.pathname, location.search, location.hash])
}
